import styled from 'styled-components';
import { Text } from '@cko/primitives';
export const DetailsPanelText = styled(Text).attrs({
    as: 'div', // Fixes an issue with <div> as a descendant of <p>
}) `
  margin: var(--layout-sandgrain);

  svg {
    vertical-align: text-bottom;
  }
`;
export const DetailsPanelInfo = styled(Text).attrs({
    as: 'div', // Fixes an issue with <div> as a descendant of <p>
}) `
  margin: var(--layout-sandgrain);

  svg {
    vertical-align: text-bottom;
  }
`;
export const DetailsPanelLabel = styled(Text) `
  font: var(--body-xs-medium);
  margin: var(--layout-sandgrain);
  color: var(--base-text-primary);
`;
export const DetailsPanelHeader = styled.header `
  width: 100%;
  background: var(--base-bg-primary);
  box-shadow: var(--control-e-spoon);
  display: inline-block;
`;
